import { type CarrierDef } from '../common.js'
import { accountNumber, password, username, userPassMap } from '../internal.js'

// CRED NOTE - legacy has account number as an account level field as well, but i don't see that being used
const credentialTypes = [username, password] as const
const locationCredentialTypes = [accountNumber] as const

export type gsonCredType =
  | (typeof credentialTypes)[number]
  | (typeof locationCredentialTypes)[number]

export const gson: CarrierDef<gsonCredType> = {
  name: 'GLS',
  scac: 'gson',
  parcelServices: [
    { id: 'priority_overnight', name: 'Priority Overnight' },
    { id: 'priority_overnight_early', name: 'Early Priority Overnight' },
    { id: 'ground', name: 'Ground' },
    { id: 'saturday_delivery', name: 'Saturday Delivery' },
    { id: 'saturday_delivery_early', name: 'Early Saturday Delivery' },
    { id: 'priority_twelve_pm', name: 'Noon Priority' },
  ],
  credentialTypes,
  locationCredentialTypes,
  legacyCredMap: [...userPassMap, ['account-number', 'ref1']],
  engineLayers: ['rating', 'pickup', 'bol', 'cancel', 'tracking'],
  credentialConfig: {
    'account-number': { customerIdentifier: true },
  },
}
